import { Stage } from '@/model';

export type QualifierZone = 'direct' | 'playoff' | 'secondary' | 'relegation' | null;

type StageCutoffs = Pick<
  Stage,
  | 'direct_qualifiers_count'
  | 'playoff_qualifiers_count'
  | 'secondary_qualifiers_count'
  | 'relegated_count'
>;

/**
 * Resolve a zona da linha (cor) a partir da posição e dos cutoffs da fase.
 *
 * Regras (ordem do topo pro fundo):
 * - Top `direct` → 'direct' (verde — ex.: Libertadores).
 * - Próximos `playoff` → 'playoff' (azul — ex.: Pré-Libertadores).
 * - Próximos `secondary` → 'secondary' (laranja — ex.: Sul-Americana).
 * - Últimos `relegated` → 'relegation' (vermelho).
 * - Resto → null (sem borda).
 *
 * Quando os 4 cutoffs estão zerados (stage sem configuração), retorna null
 * pra todas as posições — a legenda fica decorativa.
 */
export const getQualifierZone = (
  position: number,
  totalTeams: number,
  stage: StageCutoffs | undefined | null,
): QualifierZone => {
  if (!stage) return null;
  const direct = stage.direct_qualifiers_count ?? 0;
  const playoff = stage.playoff_qualifiers_count ?? 0;
  const secondary = stage.secondary_qualifiers_count ?? 0;
  const relegated = stage.relegated_count ?? 0;
  if (direct + playoff + secondary + relegated === 0) return null;

  if (position <= direct) return 'direct';
  if (position <= direct + playoff) return 'playoff';
  if (position <= direct + playoff + secondary) return 'secondary';
  if (position > totalTeams - relegated) return 'relegation';
  return null;
};

export const ZONE_BORDER_COLOR: Record<Exclude<QualifierZone, null>, string> = {
  direct: 'green.500',
  playoff: 'blue.500',
  secondary: 'orange.500',
  relegation: 'red.500',
};
